import { NgModule } from 'ng-metadata/core';
import { SearchLocationsComponent } from './search-locations.component';

@NgModule({
  declarations: [
    SearchLocationsComponent,
  ],
})
export class SearchLocationsModule {}


// WEBPACK FOOTER //
// ./resources/assets/js/common/directory/locations/search-locations.module.ts